// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sQmI","toggle":"styles_toggle__3FdOL","preview":"styles_preview__25HRK"};